<template>
    <span v-if="props.total === null" data-test="breakdown-empty" class="text-slate-500">-</span>
    <vx-popover v-else hover teleport arrow placement="top">
        <button
            type="button"
            data-test="breakdown"
            :aria-label="`${countLabel(props.total)} ${props.label}, show the breakdown`"
            class="cursor-pointer border-0 bg-transparent p-0 font-bold text-sky-700 tabular-nums hover:underline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-blue-500"
        >
            {{ countLabel(props.total) }}
        </button>
        <template v-slot:content>
            <dl class="m-0 grid grid-cols-[1fr_auto] gap-x-4 gap-y-1 text-xs">
                <template v-for="row in props.rows" :key="row.key">
                    <dt class="text-slate-600">{{ row.label }}</dt>
                    <dd class="m-0 text-right font-bold tabular-nums" :data-test="`breakdown-${row.key}`">
                        {{ countLabel(row.count) }}
                    </dd>
                </template>
            </dl>
        </template>
    </vx-popover>
</template>

<script lang="ts" setup>
import { VxPopover } from '@voxie/frontend-components';
import { countLabel, type RndCountRow } from '~/components/kiosk/kiosk-reassigned-numbers/rndLabels';

const props = defineProps<{
    total: number | null;
    rows: RndCountRow[];
    label: string;
}>();
</script>
